<div class="component-container">

    <!-- ── Encabezado ─────────────────────────────────────── -->
    <app-page-title [title]="title()"></app-page-title>

    <!-- ── Tarjetones ─────────────────────────────────────── -->
    <!-- Mismo tarjetón que el menú de Reportes y Catálogos. La lista es fija
         (SUPPORT_CARDS), así que no hay estados de carga ni conteos. -->
    <div class="menu-container">
        <div class="grid-menu">
            @for (item of menuCards; track item.route) {
                <button
                    mat-button
                    color="primary"
                    class="menu-item-btn"
                    (click)="navigationTo(item.route)">
                    <div class="button-content">
                        <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
                        <span class="menu-label">{{ item.title }}</span>
                        <p class="menu-description">{{ item.description }}</p>
                    </div>
                </button>
            }
        </div>
    </div>
</div>
